import { useBaseApiQuery } from "@query/baseQuery";


export const useClubEventTimeRulesQuery = (clubUuid) => {
    return useBaseApiQuery(
        {
            endpoint: `/eventTimeRule/club/${clubUuid}`
        },
        {
            queryKey: [`clubEventTimeRules`, clubUuid],
            enabled: !!clubUuid
        }
    );
};


export const useSiteEventTimeRulesQuery = (siteUuid) => {
    return useBaseApiQuery(
        {
            endpoint: `/eventTimeRule/site/${siteUuid}`
        },{
            queryKey: [`siteEventTimeRules`, siteUuid],
            endabled: !!siteUuid
        }
    );
};



